<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset" :offset-lg="block.offsetlg">
    <v-text-field
      :dense="true"
      class="v-label--active"
      :value="form"
      type="number"
      filled
      :min="block.min"
      :max="block.max"
      inputmode="numeric"
      :label="block.label"
      hide-details="auto"
      :suffix="block.suffix"
      :class="block.class + ' ' +block.inputClass"
      placeholder="0"
      :step="block.step"
      @input="$emit('update:form', $event)"
    />
  </v-col>
</template>

<script>
export default {
   name: 'NumberField',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: String,
         default: () => '',
      },
   },
}
</script>
<style>
   /* .v-text-field--outlined .v-label {
      font-size: 20px;
   }
   .v-text-field--outlined.v-input--dense .v-label--active {
      transform: translateY(-18px) scale(0.75);
   }
   .v-text-field--outlined input {
      outline: none;
   } */
</style>
